import { render, staticRenderFns } from "./SimpleRepairPlanPrintPage.vue?vue&type=template&id=60a36e5c&scoped=true&"
import script from "./SimpleRepairPlanPrintPage.vue?vue&type=script&lang=ts&"
export * from "./SimpleRepairPlanPrintPage.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleRepairPlanPrintPage.vue?vue&type=style&index=0&id=60a36e5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a36e5c",
  null
  
)

export default component.exports